import { render } from "./QuickMenu.vue?vue&type=template&id=d7ae48e6&scoped=true"
import script from "./QuickMenu.vue?vue&type=script&lang=js"
export * from "./QuickMenu.vue?vue&type=script&lang=js"

import "./QuickMenu.vue?vue&type=style&index=0&id=d7ae48e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ae48e6"]])

export default __exports__